// extracted by mini-css-extract-plugin
module.exports = {"linkBlockColumns":"DesktopLinkSection_linkBlockColumns__2c3eI","title":"DesktopLinkSection_title__bmvSf","linksColumn":"DesktopLinkSection_linksColumn__P7WIO"};